import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";

export type EllipsesMenuTrainingPlanProps = {
  onDuplicate: () => void;
  onAssing: () => void;
  onEdit: () => void;
};

const EllipsesMenuTrainingPlan: React.FC<EllipsesMenuTrainingPlanProps> = ({
  onDuplicate,
  onAssing,
  onEdit,
}) => {
  return (
    <Menu as="div" className="relative flex-none">
      <MenuButton className="mt-1 block p-2 text-gray-600 hover:text-gray-900">
        <span className="sr-only">Open options</span>
        <FontAwesomeIcon
          icon={faEllipsisVertical}
          aria-hidden="true"
          className="h-5 w-5"
        />
      </MenuButton>
      <MenuItems className="absolute right-0 z-50 mt-2 w-auto origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none">
        <MenuItem>
          <a
            onClick={onDuplicate}
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-gray-600 hover:text-gray-900"
          >
            {t("user.views.duplicate_workout")}
          </a>
        </MenuItem>
        <MenuItem>
          <a
            onClick={onAssing}
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-primary-600 hover:text-primary-900"
          >
            {t("user.views.assign_workout")}
          </a>
        </MenuItem>
        <MenuItem>
          <a
            onClick={onEdit}
            href="#"
            className="block px-3 py-1 text-sm leading-6 text-primary-600 hover:text-primary-900"
          >
            {t("user.views.edit_workout")}
          </a>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default EllipsesMenuTrainingPlan;
